// src/constants/projects.js

// 1) Import each image from src/assets/images:
import foodcartImg    from '../assets/images/foodcart.png';
import aiAssistantImg from '../assets/images/AI.png';
import ecommerceImg   from '../assets/images/Ecommerce.png';
import musicAppImg    from '../assets/images/Music.png';
import supermarketImg from '../assets/images/Supermarket.png';
import nexusImg       from '../assets/images/nexus.png';
import crmImg         from '../assets/images/crm.png';

const projects = [
  {
    id: 1,
    title: "FoodCart App",
    description:
      "A restaurant and home chef marketplace that allows users to browse restaurants, order food, and track deliveries. Vendors can also register their businesses.",
    image: foodcartImg,
    link: ""
  },
  {
    id: 2,
    title: "AI Assistant App (Eluma)",
    description:
      "An AI-powered assistant that provides chatbot interactions, AI-generated images, and video creation. It features an intuitive, futuristic UI with AI art and automation tools.",
    image: aiAssistantImg,
    link: ""
  },
  {
    id: 3,
    title: "E-commerce Shopping Platform",
    description:
      "A modern e-commerce platform where users can browse categories, view product details, and make purchases. Includes features like flash sales and easy checkout.",
    image: ecommerceImg,
    link: ""
  },
  {
    id: 4,
    title: "Music Streaming App",
    description:
      "A personalized music streaming app with trending playlists, favorite artists, and an engaging, neon-themed UI for an immersive listening experience.",
    image: musicAppImg,
    link: ""
  },
  {
    id: 5,
    title: "Supermarket Grocery App",
    description:
      "A grocery shopping app that lets users browse fresh fruits, dairy, and other essentials. Features a category-based shopping experience with cart and checkout functionality.",
    image: supermarketImg,
    link: ""
  },
  {
    id: 6,
    title: "Nexus CRM Dashboard",
    description:
      "A full-featured SaaS collaboration tool built with React and Node.js. Nexus allows sales teams to manage leads, track opportunities, and maintain contacts and companies—all from one intuitive interface. Features include pipeline stages (Prospecting → Qualified → Proposal → Closed), task/calendar integration, and real-time activity history.",
    image: nexusImg,
    link: ""
  },
  {
    id: 7,
    title: "SlothUI Customer Overview",
    description:
      "A modern CRM interface built with React and Tailwind CSS. This Customer Overview screen displays key metrics—such as total customers, active users, and revenue projections—alongside a searchable, filterable activity log. With a clean data-driven design, SlothUI helps account managers quickly view customer details, subscription data, and performance trends.",
    image: crmImg,
    link: ""
  }
];

export default projects;
